
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/zmiana-hasla",
      function () {
        return require("private-next-pages/zmiana-hasla/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/zmiana-hasla"])
      });
    }
  